var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoLocalCommercial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_local_commercial_-_biens_vendus",
    "data-name": "picto local commercial - biens vendus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.173,
    height: 13.785,
    viewBox: "0 0 16.173 13.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_762",
    "data-name": "Groupe 762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_345",
    "data-name": "Trac\\xE9 345",
    d: "M1.152,0h13.83V.256A3.06,3.06,0,0,0,15.4,2.348c.211.506.412,1.018.634,1.519a1.613,1.613,0,0,1,.1,1.024,1.825,1.825,0,0,1-.873,1.229.211.211,0,0,0-.117.211v7.454H1.013V6.3A.234.234,0,0,0,.9,6.086,1.886,1.886,0,0,1,.034,4.133a1.28,1.28,0,0,1,.095-.239c.323-.829.656-1.636.985-2.442a.584.584,0,0,0,.039-.223V0ZM14.465,13.112V6.381A1.953,1.953,0,0,1,12.7,5.635a1.953,1.953,0,0,1-2.743.339,2.175,2.175,0,0,1-.339-.339,1.941,1.941,0,0,1-2.726.339,1.875,1.875,0,0,1-.35-.345,1.953,1.953,0,0,1-3.076,0,2.008,2.008,0,0,1-.784.606,2.025,2.025,0,0,1-.979.145v6.726H9.769V7.071h4.039v6.041ZM10.448,7.744v2.348a1.257,1.257,0,0,1,.289,0,.556.556,0,0,1,.278.111.284.284,0,0,1,.078.334.339.339,0,0,1-.328.223h-.317V13.1h2.67V7.744Zm-8.612-6.4H14.3V.679H1.836ZM3.261,4.028l.295-1.98H1.67a.184.184,0,0,0-.128.106c-.228.584-.467,1.185-.712,1.775a.673.673,0,0,0-.028.1Zm5.969,0L9.135,2.042H7.021l-.1,1.986Zm6.119,0a.184.184,0,0,0,0-.056c-.256-.623-.506-1.246-.768-1.869a.172.172,0,0,0-.117-.067h-1.83a.122.122,0,0,0,0,.045c.089.617.184,1.235.273,1.852,0,.078.045.1.117.095h2.348ZM9.814,2.042l.095,1.986h2.331l-.295-1.986ZM6.248,4.028l.1-1.992H4.323c-.078,0-.095.039-.1.106-.05.356-.106.707-.156,1.063s-.078.556-.117.823Zm-3.093.684H.718a1.229,1.229,0,0,0,1.157,1,1.263,1.263,0,0,0,1.274-1Zm6.8,0c-.067.234.089.367.2.506a1.207,1.207,0,0,0,1.246.473,1.391,1.391,0,0,0,.923-.684.178.178,0,0,0-.161-.278Zm-3.054,0a.345.345,0,0,0,.089.389c.033.039.061.089.095.128a1.235,1.235,0,0,0,1.229.462A1.38,1.38,0,0,0,9.2,5.068a.373.373,0,0,0,.045-.356Zm-.7,0H3.895c-.111.195,0,.323.111.467a1.246,1.246,0,0,0,1.73.317A1.207,1.207,0,0,0,5.9,5.363a.729.729,0,0,0,.334-.645Zm9.24,0h-2.42a1.25,1.25,0,0,0,1.057.99,1.224,1.224,0,0,0,1.357-.985Z",
    transform: "translate(-0.002)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_346",
    "data-name": "Trac\\xE9 346",
    d: "M10.965,17.415H4.25v-4.7h6.715ZM4.923,13.393v3.338h5.363V13.393Z",
    transform: "translate(-1.887 -5.644)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_347",
    "data-name": "Trac\\xE9 347",
    d: "M9.63,16.871a1.113,1.113,0,0,1,.139-.239q.99-1.007,2-2a.334.334,0,0,1,.478,0,.328.328,0,0,1,0,.462h0c-.284.295-.556.556-.862.868L10.27,17.072a.339.339,0,0,1-.395.089.389.389,0,0,1-.245-.289Z",
    transform: "translate(-4.274 -6.446)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_348",
    "data-name": "Trac\\xE9 348",
    d: "M13.059,16.939a.345.345,0,0,1,.339.184.3.3,0,0,1-.033.345c-.245.256-.49.506-.745.745a.317.317,0,0,1-.434-.033.306.306,0,0,1-.033-.428c.239-.261.5-.506.751-.751a.317.317,0,0,1,.156-.061Z",
    transform: "translate(-5.361 -7.515)",
    fill: "#616a7d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoLocalCommercial);
export default __webpack_public_path__ + "static/media/picto_local_commercial.c30343a9.svg";
export { ForwardRef as ReactComponent };